export const HAS_ENTERED_PASSWORD_KEY = 'HasEnteredPasswordBefore';

export const ROUTES = {
  LOGIN: '/login',
  CHECK_EMAIL: '/check',
  CHOOSE_AUTH: '/choose',
  ENTER_PASSWORD: '/password',
  SET_NEW_PASSWORD: '/set_password',
};

export const getSafeDestination = (
  prevDest: string | null | undefined,
): string => {
  if (!prevDest || prevDest.includes('inbox')) {
    // If we are using the GraphQL inbox, the message view and inbox view
    // can load their own data, so drop them back to their previously viewed
    // screen.
    if (prevDest) {
      return prevDest;
    }
    return '/inbox';
  }
  if (prevDest === '/') {
    return '/inbox';
  }
  if (prevDest.includes('jobs/phonenumbers')) {
    return '/jobs/phonenumbers';
  }
  if (prevDest.includes('jobs/answers')) {
    return '/jobs/answers';
  }
  if (prevDest.includes('settings/users')) {
    return '/settings/users';
  }
  return prevDest;
};
